export default __webpack_public_path__ + "static/trent_bw-b986702f763e2544df88b6bb3e7e6ba1.jpeg";